<template>
  <div class="preview-box">
    <div class="group" :title="item.name" v-for="(item, index) in groups" :key="index">
      <!-- {{ _item }} -->
      <el-card class="box-card" shadow="never">
        <div slot="header" class="card-header">
          <slot name="checkbox" :item="item" :index="index"></slot>
          <h4>{{ item.creative_name }}</h4>
          <span>（</span>
          <template v-if="isV3">
            <span>素材：{{ materialTotal(item) }}/{{ maxCount }}</span>
          </template>
          <template v-else>
            <span>视频：{{ item.selectedMaterials.video.length }}/{{ maxCount }}、</span>
            <span>图片：{{ item.selectedMaterials.image.length }}/{{ maxCount }}、</span>
            <span>图文：{{ item.selectedMaterials.imageAudio.length }}/10</span>
          </template>
          <span>）</span>
        </div>
        <div class="material-list">
          <div class="material-box" v-for="(_item, _index) in item.selectedMaterials.video" :key="`v_${_index}`">
            <el-tag class="badge">视频{{ _index + 1 }}</el-tag>
            <div class="img-box">
              <img
                loading="lazy"
                :class="_item.height > _item.width || _item.vertical ? 'vertical' : 'horizontal'"
                :src="_item.preview_url"
                alt=""
              />
            </div>

            <p class="material-name">{{ _item.name || _item.video_info.title }}</p>
          </div>
          <div class="material-box" v-for="(_item, _index) in item.selectedMaterials.image" :key="`i_${_index}`">
            <el-tag class="badge">图片{{ _index + 1 }}</el-tag>
            <div class="img-box">
              <img loading="lazy" :class="_item.height > _item.width ? 'vertical' : 'horizontal'" :src="_item.preview_url" alt="" />
            </div>

            <p class="material-name">{{ _item.name || _item.video_info.title }}</p>
          </div>
          <div class="material-box" v-for="(_item, _index) in item.selectedMaterials.imageAudio" :key="`iv_${_index}`">
            <el-tag class="badge">图文{{ _index + 1 }}</el-tag>
            <div class="img-box">
              <img loading="lazy" :class="_item.height > _item.width ? 'vertical' : 'horizontal'" :src="_item.preview_url" alt="" />
            </div>

            <p class="material-name">{{ _item.name || _item.video_info.title }}</p>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef } from 'vue'
// eslint-disable-next-line
const props = defineProps({ groups: Array, maxCount: Number, isV3: Boolean })
const groups = toRef(props, 'groups')
const materialTotal = (item) => {
  const { video = [], image = [], imageAudio = [] } = item.selectedMaterials || {}
  return video.length + image.length + imageAudio.length
}
</script>

<style lang="scss" scoped>
.preview-box {
  height: 720px;
  padding: 10px;
  overflow: auto;
}
::v-deep .group {
  margin-bottom: 15px;
  .el-card__header {
    padding: 12px 10px;
    font-size: 14px;
    background: #eeeeee;
    .card-header {
      display: flex;
      align-items: center;
    }
  }
  .el-card__body {
    padding: 5px 10px;
  }

  .materials {
    &-row {
      display: flex;
      overflow: auto;
      margin-bottom: 5px;

      > div {
        margin-right: 5px;
      }
    }
  }
}
.material-list {
  display: flex;
  justify-content: flex-start;
  overflow: auto;
  overflow-y: hidden;
  width: 100%;
  padding-bottom: 4px;
  .material-box {
    min-width: 110px;
    width: 110px;
    height: 78px;
    margin-right: 5px;
    text-align: center;
    position: relative;
    .img-box {
      border-radius: 4px;
      overflow: hidden;
      height: 62px;
      background: #eee;
      .horizontal {
        width: 100%;
      }
      .vertical {
        height: 100%;
      }
    }
    .material-name {
      width: 110px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .badge {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      font-size: 12px;
      transform: scale(0.8);
      transform-origin: 0 0;
    }
  }
}
</style>
